import { render, staticRenderFns } from "./ConfiguratorModal.vue?vue&type=template&id=79481f26"
import script from "./ConfiguratorModal.vue?vue&type=script&lang=js"
export * from "./ConfiguratorModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports